import { DateTime } from 'luxon'

export const getSliderValueFromDate = (date: string): number => DateTime.fromISO(date).ordinal - 4
